import { DownOutlineIcon, InfoOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, Dropdown, TextBase, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useState } from 'react';
import {
  type IShareDropdownItem,
  ShareDropdownItem,
} from './ShareDropdownItem';

interface ShareDropdownMenuProps {
  selectedItem: IShareDropdownItem;
  items: IShareDropdownItem[];
  onSelect: (item: IShareDropdownItem) => void;
  infoText?: string;
}

export const ShareDropdownMenu = ({
  selectedItem,
  items,
  onSelect,
  infoText,
}: ShareDropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const SelectedItem = () => (
    <div
      className={classNames(
        'flex flex-1 items-center py-3 cursor-pointer border border-transparent rounded-md text-ds-primary-300 bg-ds-natural-50 text-left',
        { 'border-ds-primary-300': isOpen }
      )}
    >
      <div className="p-3">{selectedItem.icon}</div>
      <div className="flex flex-1 flex-col">
        <div className="flex h-6 items-center">
          <TextBase
            label={selectedItem.label}
            color="text-ds-primary-300"
          />
          {infoText && (
            <div className="ml-1">
              <TooltipBubble
                title={infoText}
                placement="top-start"
              >
                <InfoOutlineIcon
                  color={ColorHex.natural300}
                  size="18"
                />
              </TooltipBubble>
            </div>
          )}
        </div>
        <TextBase
          label={selectedItem.description}
          color="text-ds-natural-300"
        />
      </div>
      <div className="p-3">
        <DownOutlineIcon size={24} />
      </div>
    </div>
  );

  return (
    <Dropdown
      triggerElement={<SelectedItem />}
      onOpenChange={setIsOpen}
      width="100%"
      contentClass="shadow-ds-lg"
    >
      <div className="p-6 w-ds-600">
        {items.map((item) => (
          <ShareDropdownItem
            onClick={() => {
              onSelect(item);
            }}
            isSelected={item.id === selectedItem.id}
            key={item.id}
            {...item}
          />
        ))}
      </div>
    </Dropdown>
  );
};
